import { connect } from 'react-redux';

import ScribeFinalTranscriptList from './ScribeFinalTranscriptList';

const mapStateToProps = state => {
  const {
    scribeConversation: { transcripts },
    scribeTranscriptUI: { electronCaptionMode },
  } = state;
  return {
    transcripts,
    electronCaptionMode,
  };
};

export default connect(mapStateToProps)(ScribeFinalTranscriptList);
